module.exports = __webpack_public_path__ + "static/568b2188b4ac07f5b47c76a0f4af1c073f189f454925e15ba9eb93a23903e705-8831d9aa361babb45e992348ba15f9af.png";